export default "__VITE_ASSET__49a3cb2c__"